<template>
    <v-container fluid>
        <v-navigation-drawer v-model="drawer" app right clipped>
            <v-list dense>
                <v-list-item link :to="{ path: '/' }">
                    <v-list-item-icon>
                        <v-icon>mdi-home</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>
                        Hjem
                    </v-list-item-title>
                </v-list-item>

                <v-list-group value="true" sub-group>
                    <template v-slot:activator>
                        <v-list-item-title>Hvad kan jeg bruge gofiqr til</v-list-item-title>
                    </template>
                    <v-list-item v-for="(usage, i) in usages" :key="i" link class="usage-menu" :to="usage.link">
                        <v-list-item-title v-text="usage.title"/>
                    </v-list-item>
                </v-list-group>

                <v-list-item v-for="(menuItem, i) in topMenuItems" :key="i" link :to="menuItem.link">
                    <v-list-item-title v-text="menuItem.title"/>
                </v-list-item>
            </v-list>
        </v-navigation-drawer>
        <v-app-bar app clipped-right flat height="126" class="pt-1">
            <v-card :href="{path: '/'}" flat width="200" class="ma-0 pa-0">
                <v-img :src="require('@/assets/Logo-gofiqr.jpg')" height="100" contain position="left"/>
            </v-card>
            <v-spacer></v-spacer>
            <v-app-bar-nav-icon @click.stop="drawer = !drawer"/>
        </v-app-bar>
    </v-container>
</template>
<script>
    export default {
        name: 'NavBar',
        props: {},
        data: () => ({
            drawer: false,
            usages: [
                {title: 'Produktinformation', link: {path: '/produktinformation'}},
                {title: 'Intern videsdeling', link: {path: '/intern-vidensdeling'}},
                {title: 'Profilering', link: {path: '/profilering'}},
            ],
            topMenuItems: [
                {title: 'Nyheder', link: {path: '/nyheder'}},
                {title: 'Om gofiqr', link: {path: '/om'}},
                {title: 'Kontakt', link: {path: '/kontakt'}},
            ],
        }),
    }
</script>
<style>
    .usage-menu {
        background-color: #f8f8f8;
    }
</style>